import type { SiteSettings } from '@/lib/types';

export interface SiteImageSlot {
  key: string;
  label: string;
  group: string;
  defaultUrl: string;
}

/**
 * Every editable image on the public website. Admins can replace any of these
 * from Admin → Site Settings → Website Images, either with an uploaded photo or
 * a photo from the media library.
 */
export const SITE_IMAGE_SLOTS: SiteImageSlot[] = [
  {
    key: 'welcome_image',
    label: 'Home — Welcome Section',
    group: 'Home Page',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/603ca32a-3de9-4ccf-97a7-9ef2481f8546_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-5.webp',
  },
  {
    key: 'cta_image',
    label: 'Home — Call to Action Banner',
    group: 'Home Page',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/66b0c0ea-15a5-4160-915f-b54a85c2a275_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-2.webp',
  },
  {
    key: 'impact_image',
    label: 'Home — Impact Statistics Background',
    group: 'Home Page',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/7dd190bd-a977-4941-b5f7-34b8b48612b1_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-3.webp',
  },
  {
    key: 'events_hero',
    label: 'Events Page Hero',
    group: 'Events & Media',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/d4b76b2d-0b00-4684-9b37-6b17601f9688_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-1.webp',
  },
  {
    key: 'live_hero',
    label: 'Watch Live Page Hero',
    group: 'Events & Media',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/1ab415ec-9dc5-4ff9-83f5-083be47621da_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-1.webp',
  },
  {
    key: 'news_hero',
    label: 'News & Blog Hero',
    group: 'Events & Media',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/ff81ec1f-f688-499e-9bb3-724007ada18b_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-7.webp',
  },
  {
    key: 'highlights_hero',
    label: 'Highlights Gallery Hero',
    group: 'Events & Media',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/47fcfdce-9fca-4de5-be2f-48ee60c3afb0_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-8.webp',
  },
  {
    key: 'give_hero',
    label: 'Give / Donate Page Hero',
    group: 'Giving',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/4b9bbad6-29fd-42ea-83aa-a1c3fd98a35c_compressed_WhatsApp-Image-2026-09-12-at-15.29.02.webp',
  },
  {
    key: 'pureheart_hero',
    label: 'PureHeart Page Hero',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/dcf4943e-8e79-4023-9c15-6887cfd14a32_compressed_WhatsApp-Image-2026-09-10-at-8.19.32-AM.webp',
  },
  {
    key: 'pureheart_grid_1',
    label: 'PureHeart Photo 1',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/603ca32a-3de9-4ccf-97a7-9ef2481f8546_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-5.webp',
  },
  {
    key: 'pureheart_grid_2',
    label: 'PureHeart Photo 2',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/1ab415ec-9dc5-4ff9-83f5-083be47621da_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-1.webp',
  },
  {
    key: 'pureheart_grid_3',
    label: 'PureHeart Photo 3',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/d4b76b2d-0b00-4684-9b37-6b17601f9688_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-1.webp',
  },
  {
    key: 'pureheart_grid_4',
    label: 'PureHeart Photo 4',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/3fe90688-4f52-4024-8d3f-b6f0e72c7cf7_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-6.webp',
  },
  {
    key: 'pureheart_giving',
    label: 'PureHeart Donation Image',
    group: 'PureHeart Program',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/47fcfdce-9fca-4de5-be2f-48ee60c3afb0_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-8.webp',
  },
  {
    key: 'testimonials_hero',
    label: 'Testimonials Page Hero',
    group: 'Other Pages',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/740044af-41e0-4bdf-81d7-177bf0e063c3_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-4.webp',
  },
  {
    key: 'terms_hero',
    label: 'Terms of Use Hero',
    group: 'Other Pages',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/3fe90688-4f52-4024-8d3f-b6f0e72c7cf7_compressed_WhatsApp-Image-2026-09-12-at-15.29.03-6.webp',
  },
  {
    key: 'privacy_hero',
    label: 'Privacy Policy Hero',
    group: 'Other Pages',
    defaultUrl: 'https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/7dd190bd-a977-4941-b5f7-34b8b48612b1_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-3.webp',
  },
];

export function defaultSlotUrl(key: string): string {
  return SITE_IMAGE_SLOTS.find((s) => s.key === key)?.defaultUrl ?? '';
}

/**
 * Resolve the image for a slot: admin override → slot default → supplied fallback.
 */
export function resolveSlotImage(
  settings: SiteSettings | null | undefined,
  key: string,
  fallback?: string,
): string {
  const override = settings?.image_slots?.[key];
  if (typeof override === 'string' && override.trim()) return override;
  return fallback || defaultSlotUrl(key);
}